import { useMutation, useQueryClient } from "@tanstack/react-query";
// types
import { TRefundRequest, TRefundResponse } from "../types/refund-type";
// lib
import apiClient from "../../../../api/axios";

const ORDER_REFUNDS_BASE_URL = "/order_refunds";
const QUERY_KEY = "order-refunds";

export const useCreateRefund = (restaurantId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      orderId,
      payload,
    }: {
      orderId: string;
      payload: TRefundRequest;
    }) => {
      const response = await apiClient.post<TRefundResponse>(
        `${ORDER_REFUNDS_BASE_URL}/${orderId}/refund`,
        payload,
        {
          headers: {
            "Restaurant-ID": restaurantId,
          },
        },
      );
      return response.data?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
};

export const refundService = {
  useCreateRefund,
};
